import {useEffect, useMemo} from 'react';
import { useLocation } from "react-router-dom";

const LastVisited = () => {
    const { pathname } = useLocation();

    function getPath () {

        const date = () => {

            const options = {year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };

            const d = new Date();

            return d.toLocaleDateString('en-us', options);
        }

        return (
            {
                pathname: pathname,
                time: date(),
            }
        );
    }

    var pathMemo = useMemo(getPath, [pathname]);

    useEffect(() => {
        const handler = () => {
            localStorage.setItem('lastVisit', JSON.stringify(pathMemo));
            localStorage.removeItem('visit_status');
        };
        window.addEventListener('beforeunload', handler);
        return () => {
            window.removeEventListener('beforeunload', handler);
        };
    }, [pathMemo]);

 return null;
}

export default LastVisited;